document.addEventListener("DOMContentLoaded", () => {
  const carousel = document.querySelector(".wide-carousel");

  if (carousel) {
    const autoplayEnabled = carousel.dataset.autoplay === "true";

    const swiper = new Swiper(".wide-carousel", {
      loop: true,
      slidesPerView: 1,
      autoplay: autoplayEnabled
        ? {
            delay: 5000,
            disableOnInteraction: false,
          }
        : false,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }
});
